/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { useJwtClaims } from '../Context/AuthContext';

// eslint-disable-next-line import/prefer-default-export
export const useSentryMonitoring = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const [setupCompleted, setCompleted] = useState(false);
  const { profileId, email } = useJwtClaims();

  useEffect(() => {
    if (dsn) {
      console.debug('Initializing sentry monitoring ...');
      Sentry.init({ dsn, sendDefaultPii: true });
      setCompleted(true);
    } else {
      console.warn('Sentry monitoring is disabled for this env');
    }
  }, [dsn]);

  useEffect(() => {
    if (setupCompleted && profileId) {
      console.debug('Identifying user');
      Sentry.setUser({ id: profileId, email });
    }
  }, [setupCompleted, profileId, email]);
};
